import { Controller } from '@hotwired/stimulus';
import Hls from 'hls.js';

export class VideoController extends Controller {
  static targets = [
    'button',
    'video',
    'playTemplate',
    'pauseTemplate',
  ];

  disconnect() {
    if (this.hls) this.hls.destroy();
  }

  async pause() {
    await this.videoTarget.pause();

    this.buttonTarget.innerHTML = this.playTemplateTarget.innerHTML;
  }

  async play() {
    await this.ensureHlsLoaded();
    await this.videoTarget.play();

    this.buttonTarget.innerHTML = this.pauseTemplateTarget.innerHTML;
  }

  async toggle() {
    if (!this.hasVideoTarget) return;
    if (this.videoTarget.paused) return await this.play();

    await this.pause();
  }

  async ensureHlsLoaded() {
    const src = this.videoTarget.getAttribute('src');

    if (!src || this.hls || this.videoTarget.canPlayType('application/vnd.apple.mpegurl')) {
      return;
    }

    if (Hls.isSupported()) {
      this.hls = new Hls();
      this.hls.loadSource(src);
      this.hls.attachMedia(this.videoTarget);
      await this.hls.startLoad?.();
    }
  }
}
